import React from "react"
import types from "prop-types"
import { dayRangeTaskInclusionDescription, dynamicRangeTasksExample } from "utils/scheduledReportExportHelpers"

const DaysTaskDateDescription = ({ dateFilterType, startDate, taskPreviousRangeLength = null }) => {
  const daysCount = taskPreviousRangeLength || 1

  const beginningDate = startDate.subtract(daysCount, "d")
  const endingDate = startDate.subtract(1, "d")

  return (
    <div className="text-xs text-dark mt-2">
      <p className="mb-4">
        {dayRangeTaskInclusionDescription(dateFilterType)}
      </p>
      <p>
        {dynamicRangeTasksExample({
          startDate, beginningDate, endingDate, dateFilterType,
        })}
      </p>
    </div>
  )
}

DaysTaskDateDescription.propTypes = {
  dateFilterType: types.string.isRequired,
  startDate: types.object.isRequired,
  taskPreviousRangeLength: types.number,
}

export default DaysTaskDateDescription
